export const BOOKING_DATE_FORMAT = "yyyy-MM-dd";
export const BOOKING_DATE_FORMAT_FOR_MAIN_FORM = "dd-MM-yyyy";
export const MAIN_DATE_FORMAT = "d MMMM";
export const FROM_TO_DATE_FORMAT = "dd MMMM";
